import React from 'react';

import { HiddenClipPath } from './styles';

export interface TickClipPathProps {
    id?: string;
}

export const TickClipPathDefaultId = 'TickClipPath';

// This SVG is crafted specifically to be:
// 1. Rendered only once within the DOM.
//  - If rendered a 2nd time, a unique `id` should be provided.
// 2. Rendered as an invisible element with no layout dimensions.
// 3. Referenced via CSS `clip-path: url(#id);`.
// 4. Size is flexible and will fit the `width / height` of its parent.
export function TickClipPath({ id = TickClipPathDefaultId }: TickClipPathProps) {
    return (
        <HiddenClipPath>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1" width="0" height="0" preserveAspectRatio="none">
                <clipPath id={id} clipPathUnits="objectBoundingBox">
                    <path d="M.262.103A.152.152 0 0 1 .407 0h.491a.1.1 0 0 1 .097.131L.738.897A.152.152 0 0 1 .593 1H.102A.1.1 0 0 1 .005.869L.262.103Z" />
                </clipPath>
            </svg>
        </HiddenClipPath>
    );
}
